"use client";
import Script from "next/script";

const isProduction = process.env.NODE_ENV === "production";

// 客服挂件，10/31 从 Orka 换成 tawk.to 免费版
export function TawkScript() {
	if (!isProduction) {
		return null;
	}

	return (
		<Script
			id="tawk-chat-widget"
			strategy="lazyOnload"
			dangerouslySetInnerHTML={{
				__html: `
          var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
          (function(){
            var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
            s1.async=true;
            s1.src="https://embed.tawk.to/6ae5d452a8df8c3c36f4778d/1k68sapch";
            s1.charset="UTF-8";
            s1.setAttribute("crossorigin","*");
            s0.parentNode.insertBefore(s1,s0);
          })();
        `,
			}}
		/>
	);
}
